"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellOccupied = exports.scriptOccupied = void 0;
const codeHashOccupied = 32;
const hashTypeOccupied = 1;
const scriptOccupied = (script) => {
    return script.args.slice(2).length / 2 + codeHashOccupied + hashTypeOccupied;
};
exports.scriptOccupied = scriptOccupied;
const cellOccupied = (cell) => {
    return 8 + (0, exports.scriptOccupied)(cell.lock) + (cell.type ? (0, exports.scriptOccupied)(cell.type) : 0);
};
exports.cellOccupied = cellOccupied;
//# sourceMappingURL=occupiedCapacity.js.map